import Form from "react-bootstrap/Form";
import { FaRedo } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import { Row } from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import { Link } from "react-router-dom";

import "./index.scss";

const CertificateForm = ({
  handleSubmit,
  isUserMobile,
  setIsUserMobile,
  sendOtpApi,
  isUserOtp,
  setIsUserOtp,
  showResendOtpTimer,
  setShowResendOtpTimer,
  formatTime,
  reSendOtpApi,
  showNavigationRouter,
  handleRefresh,
  timeLeft,
  setTimeLeft,
  isOtpSent,
  isCertificateLoading,
}) => {
  return (
    <Form noValidate onSubmit={handleSubmit} className="certificate-form">
      <Row className="certificate-form__row">
        <Form.Group controlId="validationFormikUsername">
          <Form.Label className="certificate-form__label">Mobile</Form.Label>

          <InputGroup hasValidation>
            <Form.Control
              type="text"
              maxLength={10}
              name="isUserMobile"
              value={isUserMobile}
              className="certificate-form__input"
              aria-describedby="inputGroupPrepend"
              placeholder="Enter mobile number"
              onChange={(e) => {
                sendOtpApi(e?.target.value);
                setIsUserMobile(e?.target.value);
              }}
            />
          </InputGroup>
        </Form.Group>
      </Row>

      <Row className="certificate-form__row">
        <Form.Group controlId="validationFormikUsername">
          <Form.Label className="certificate-form__label">Otp</Form.Label>

          <InputGroup hasValidation>
            <Form.Control
              type="text"
              name="isUserOtp"
              value={isUserOtp}
              className="certificate-form__input"
              aria-describedby="inputGroupPrepend"
              placeholder="Enter Otp"
              onChange={(e) => setIsUserOtp(e?.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </Row>

      {isOtpSent && (
        <Row className="certificate-form__otp-row">
          {showResendOtpTimer ? (
            <p className="certificate-form__timer">
              You can resend OTP in 0{formatTime(timeLeft)}
            </p>
          ) : (
            <span
              className="certificate-form__resend-link"
              onClick={() => {
                setShowResendOtpTimer(true);
                setTimeLeft(300);
                reSendOtpApi(isUserMobile);
              }}
            >
              Resend OTP
            </span>
          )}
        </Row>
      )}

      <Button
        type="submit"
        disabled={isCertificateLoading}
        className={`certificate-form__submit-btn ${
          isCertificateLoading ? "certificate-form__submit-btn--disabled" : ""
        }`}
      >
        {isCertificateLoading ? "Loading..." : "View Certificate"}
      </Button>

      {showNavigationRouter && (
        <div className="certificate-form__reupload">
          <p>
            <Link
              to="https://apb.acrossassist.com/"
              className="certificate-form__link"
              target="_blank"
            >
              Re-Upload your Details/Video again.
            </Link>
          </p>
        </div>
      )}

      {isUserMobile && (
        <div className="certificate-form__refresh-container">
          <Button
            variant="secondary"
            onClick={handleRefresh}
            className="certificate-form__refresh-btn"
          >
            <FaRedo className="certificate-form__refresh-icon" /> Refresh
          </Button>
        </div>
      )}
    </Form>
  );
};

export default CertificateForm;
